// import config from '../const'
export default {
  computed: {
    get_base_env: function () {
      return process.env.NODE_ENV
    },
    mgw_phase_production_001: function () {
      if (process.env.NODE_ENV == 'production') {
        return true
      } else {
        return false
      }
    },
    vue_node_env: function () {
      return process.env.NODE_ENV
    },
    dev_msg: function () {
      const node_env = process.env.NODE_ENV
      return function (msg) {
        if (node_env != 'production') {
          return '<<' + msg + '>>'
        }
        return ''
      }
    },
    // ワイルドカード(*)を正規表現に変換する関数
    page_path_reg_exp: function () {
      return function (pattern) {
        console.log('pattern', pattern)
        const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&')
        // 特殊文字をエスケープして、* を .* に置換
        return new RegExp('^' + escaped.replace(/\*/g, '.*') + '$')
      }
    },
    // どれか一つ一致
    chk_relation_prefix_target_some: function () {
      const chk_p = this.chk_relation_prefix_target
      return function (targets) {
        if (!Array.isArray(targets)) return false
        return targets.some(target => {
          return chk_p(target)
        })
      }
    },
    // すべて一致
    chk_relation_prefix_target_every: function () {
      const chk_p = this.chk_relation_prefix_target
      return function (targets) {
        if (!Array.isArray(targets)) return false
        return targets.every(target => {
          return chk_p(target)
        })
      }
    },
    chk_relation_prefix_target: function () {
      const roles = this.$store?.state?.auth?.relations
      const level = this.$store?.state?.auth?.level
      return function (target) {
        if (parseInt(level) > 0) {
          if (!Array.isArray(roles)) return false

          return roles.some(role => {
            const pp = role?.page_path
            if (!pp) return false
            return pp.startsWith(target)
          })
        }
        return true
      }
    },
    chk_relation_target: function () {
      const roles = this.$store?.state?.auth?.relations
      const level = this.$store?.state?.auth?.level
      const reg_exp = this.page_path_reg_exp
      return function (target) {
        if (parseInt(level) > 0) {
          if (
            Array.isArray(roles) &&
            roles.find(role => {
              console.log('role.page_path', role.page_path)
              const regex = reg_exp(role.page_path)
              return regex.test(target)
            })
          ) {
            return true
          }
          return false
        }
        return true
      }
    },
    chk_relation_type_editable: function () {
      const chk_p = this.chk_relation_target_type
      return function (target) {
        if (chk_p(target) == 'editable') {
          return true
        }
        return false
      }
    },
    chk_relation_target_type: function () {
      const roles = this.$store?.state?.auth?.relations
      const level = this.$store?.state?.auth?.level
      const reg_exp = this.page_path_reg_exp
      return function (target) {
        if (parseInt(level) > 0) {
          if (!Array.isArray(roles)) return false
          const tar_roles = roles.filter(role => {
            const regex = reg_exp(role.page_path)
            return regex.test(target)
          })
          if (Array.isArray(tar_roles) && tar_roles.length > 0) {
            if (tar_roles.find(role => role.target_type == 'editable')) {
              return 'editable'
            }
            return 'visible'
          }
          return false
        }
        return 'editable'
      }
    },
    // axiosHeader: function(){
    //     return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    // },
    // cHeader: function(){
    //     return {headers: this.axiosHeader};
    // },
    manage_account_level_disp: function () {
      if (
        typeof this.$store.state.auth === 'object' &&
        this.$store.state.auth.userId != '' &&
        [1, 2, 4, 27].includes(parseInt(this.$store.state.auth.userId))
      ) {
        return true
      } else {
        return false
      }
    },
    get_main_clinic_id: function () {
      if (
        typeof this.$store.state.auth.relations === 'object' &&
        Object.keys(this.$store.state.auth.relations).length > 0
      ) {
        return this.$store.state.auth.relations[0]
      } else {
        return ''
      }
    },
    get_relation_clinic: function () {
      if (
        typeof this.$store.state.auth.relations === 'object' &&
        Object.keys(this.$store.state.auth.relations).length > 0
      ) {
        return this.$store.state.auth.relations
      } else {
        return []
      }
    },
    get_clinic_relation_where: function () {
      if (
        typeof this.get_relation_clinic === 'object' &&
        Object.keys(this.get_relation_clinic).length > 0
      ) {
        return { ids: this.get_relation_clinic }
      } else {
        return { id: 0 }
      }
    },
    get_staff_relation_where: function () {
      if (this.$store.state.auth.level == 0) {
        return { pagegroup: 'staff_data.id' }
      } else if (
        typeof this.get_relation_clinic === 'object' &&
        Object.keys(this.get_relation_clinic).length > 0
      ) {
        return { clinic_ids: this.get_relation_clinic, pagegroup: 'staff_id' }
      } else {
        return { clinic_id: 0 }
      }
    },
    get_page_num_list: function () {
      return [
        {
          key: 10,
          label: '10件'
        },
        {
          key: 25,
          label: '25件'
        },
        {
          key: 50,
          label: '50件'
        },
        {
          key: 100,
          label: '100件'
        }
      ]
    },
    get_wareki_bs: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (date) {
        if (regex1.test(date)) {
          console.log('get_wareki', regex1.test(date), date)
          return new Date(date).toLocaleDateString('ja-JP-u-ca-japanese', {
            dateStyle: 'long'
          })
        }
        return date
      }
    },
    get_lists_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    calc_age: function () {
      return function (birth_date) {
        if (!birth_date) return ''

        // "YYYY-MM-DD" or "YYYY/MM/DD" に対応
        const parts = String(birth_date).split(/[-/]/)
        if (parts.length < 3) return ''

        const year = parseInt(parts[0], 10)
        const month = parseInt(parts[1], 10) // 1-12
        const day = parseInt(parts[2], 10) // 1-31
        if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day))
          return ''

        const today = new Date()
        const thisYearsBirthday = new Date(today.getFullYear(), month - 1, day)
        if (isNaN(thisYearsBirthday.getTime())) return ''

        let age = today.getFullYear() - year
        if (today < thisYearsBirthday) age-- // 今年の誕生日がまだなら1引く
        return age
      }
    },

    // 申請承認時の参加許諾書判定に使う
    // sports_year:年度,
    calc_sports_age_2: function () {
      return function (sports_year, birth_date) {
        const [year] =
          typeof birth_date === 'string'
            ? birth_date.split('-').map(Number)
            : [0]
        // // 4-12月は年度に応じて
        // if(birth_year > 0 && month>=4 && month<=12){
        //   return (sports_year) - birth_year
        // }
        // else if(birth_year > 0 && month<=3 && month>=1){
        //   return (sports_year) - birth_year
        // }
        return sports_year - year ? sports_year - year : 0
      }
    },
    calc_sports_age: function () {
      return function (birth_date) {
        if (birth_date && !isNaN(new Date(birth_date).getDate())) {
          // 誕生年
          let birthday_year = birth_date.substr(0, 4)
          // 誕生月
          let birthday_mon = birth_date.substr(6, 2)
          // 誕生日
          let birthday_day = birth_date.substr(9, 2)

          const sNum = []
          for (let i = 1; i < 10; i++) sNum.push('0' + String(i))
          if (sNum.includes(birthday_mon)) {
            birthday_mon = sNum.indexOf(birthday_mon) + 1
          }
          if (sNum.includes(birthday_day)) {
            birthday_day = sNum.indexOf(birthday_day) + 1
          }

          //今日
          var today = new Date()
          //今年の
          // var thisYearsBirthday = new Date(today.getFullYear(), birthday_mon-1, birthday_day);
          //年齢
          var age = today.getFullYear() - parseInt(birthday_year)
          // if(today < thisYearsBirthday){
          //     //今年まだ誕生日が来ていない
          //     age--;
          // }
          return age
        }
        return ''
      }
    },
    calc_sports_age_: function () {
      return function (birth_date, sports_year) {
        if (birth_date && !isNaN(new Date(birth_date).getDate())) {
          // 誕生年
          let birthday_year = birth_date.substr(0, 4)
          // 誕生月
          let birthday_mon = birth_date.substr(6, 2)

          let age = ''
          // 早生まれ
          if (['01', '02', '03'].includes(birthday_mon)) {
            age = parseInt(sports_year) - parseInt(birthday_year)
            age = age + 1
          } else {
            age = parseInt(sports_year) - parseInt(birthday_year)
          }
          return age
          // // 誕生日
          // let birthday_day = birth_date.substr(9, 2);

          // const sNum = [];
          // for(let i=1;i<10;i++) sNum.push('0'+String(i));
          // if(
          //     sNum.includes(birthday_mon)
          // ){
          //     birthday_mon = sNum.indexOf(birthday_mon) + 1;
          // }
          // if(
          //     sNum.includes(birthday_day)
          // ){
          //     birthday_day = sNum.indexOf(birthday_day) + 1;
          // }

          // //今日
          // var today = new Date();
          // //今年の
          // var thisYearsBirthday = new Date(today.getFullYear(), birthday_mon-1, birthday_day);
          // // 年齢
          // var sportsYearDate = new Date(sports_year, 2, 31);
          // //年齢
          // var age = today.getFullYear() - parseInt(birthday_year);
          // if(sportsYearDate < thisYearsBirthday){
          // // if(today < thisYearsBirthday){
          //     //今年まだ誕生日が来ていない
          //     age--;
          // }
          // return age;
        }
        return ''
      }
    }
  },
  methods: {
    number_format(value) {
      if (typeof value !== 'number' && typeof value !== 'string') return value
      return value.toString().replace(/(\d+?)(?=(?:\d{3})+$)/g, function (x) {
        return x + ','
      })
    },
    is_json(value) {
      try {
        JSON.parse(value)
      } catch (error) {
        return false
      }
      return true
    }
    // setParams(params, mode){
    //     const params_ = new URLSearchParams();
    //     if(params){
    //         const keys = Object.keys(params);
    //         for(let i=0; i < keys.length; i++){
    //             if(
    //                 keys[i] == 'p'
    //                 // || keys[i].indexOf('page') >= 0
    //             ){
    //                 params_.append(keys[i], params[keys[i]]);
    //             }
    //             else if(params[keys[i]] !== null && typeof params[keys[i]] === 'object'){
    //                 params_.append(mode + '[' + keys[i] + ']', JSON.stringify(params[keys[i]]));
    //             }
    //             else{
    //                 params_.append(mode + '[' + keys[i] + ']', params[keys[i]]);
    //             }
    //         }
    //     }
    //     return params_;
    // },
    // setParams_S(params){
    //     return this.setParams(params, 'sprm');
    // },
    // setParams_I(params){
    //     return this.setParams(params, 'iprm');
    // },
  }
}
